// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8298d98","root":"_2e9daad","itemText":"_90f7d82","avatar":"_8fa729a"};